export default __webpack_public_path__ + "static/media/conteudo.87cfab21.png";